<template>
  <h2 class="c-title">{{ title }}</h2>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.c-title {
  width: 100%;
  text-align: center;
  background: #fff8f8;
  padding: 5px;
  box-sizing: border-box;
  margin: 30px 0 20px;
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #bc284a;
}
</style>